export function addCurrent(techinicalteamorganization) {
    return {
        type: 'ADD_CURRENT',
        techinicalteamorganization,
    }
}
